export default function CitySelect () {
  const WRAPPERS = document.querySelectorAll('.city-select')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]
      const SELECT = WRAPPER.querySelector('select')
      const BUTTON = WRAPPER.querySelector('button')
      if (SELECT && BUTTON) {
        BUTTON.addEventListener('click', () => {
          const href = SELECT.options[SELECT.selectedIndex].value
          href && (window.location.href = href)
        })
      }
    }
  }
}
